// extracted by mini-css-extract-plugin
export default {"error":"Alert_error__iwVGr","modal":"Alert_modal__qYvHM","header":"Alert_header__ZrCHm","message":"Alert_message__spg-K","button":"Alert_button__1q342"};